<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span
        class="d-flex justify-content-between align-items-center p-3 globalborder-btm-header">
        <span class="col-auto">
          <h2 class="mb-0">Ready To Bill Report</h2>
        </span>
        <span class="d-flex gap-2 align-items-center customizefilter-btn">
          <span>
            <p-button
              label="Export Excel"
              variant="outlined"
              icon="pi pi-cloud-upload"
              severity="secondary"
              (click)="exportExcelFile()"
              class="fullwdth secondary-btn" />
          </span>
          <span
            *ngIf="fromDashboard"
            class="cross-border"
            (click)="onCloseModal()"
            ><i class="pi pi-times"></i
          ></span>
        </span>
      </span>
      <div class="col-12 m-3">
        <div
          class="main-container d-flex justify-content-start align-items-center">
          <div class="field-wrap">
            <div class="form-group has-float-label">
              <label class="form-label" for="bcSelectedId">
                Branding Consultant
              </label>
              <p-select
                [options]="bcList"
                [(ngModel)]="bcSelectedId"
                [filter]="true"
                [showClear]="true"
                optionLabel="firstNameLastNamePersonalNumber"
                optionValue="id"
                placeholder="Select Branding Consultant"
                (onChange)="
                  dt.filter(getBcSelectedName(bcSelectedId), 'bcId', 'contains')
                ">
                <ng-template let-item pTemplate="item">
                  {{
                    (item?.firstName || "") +
                      " " +
                      (item?.lastName || "") +
                      " " +
                      "(" +
                      item?.personnelNumber +
                      ")"
                  }}
                </ng-template>
              </p-select>
            </div>
          </div>
          <div class="field-wrap mt-4 px-4 gap-2 d-flex">
            <span class="ip-created-label align-self-center">IP Created:</span>
            <div
              class="form-group d-flex gap-2 align-center justify-content-between">
              <div class="gap-2 d-flex nav-link p-0 d-flex align-items-center">
                <p-radiobutton
                  id="Yes"
                  name="radio"
                  value="Yes"
                  [(ngModel)]="selectedRadioButton"
                  (onClick)="getMainFiltersOnChange($event)" />

                <label class="link mt-1">Yes</label>
              </div>

              <div class="gap-2 d-flex nav-link p-0 d-flex align-items-center">
                <p-radiobutton
                  id="No"
                  type="radio"
                  class="me-2"
                  name="radio"
                  checked="true"
                  [(ngModel)]="selectedRadioButton"
                  value="No"
                  (onClick)="getMainFiltersOnChange($event)" />

                <label class="link mt-1">No</label>
              </div>

              <div class="gap-2 d-flex nav-link p-0 d-flex align-items-center">
                <p-radiobutton
                  id="All"
                  [(ngModel)]="selectedRadioButton"
                  value="All"
                  type="radio"
                  class="me-2"
                  name="radio"
                  (onClick)="getMainFiltersOnChange($event)" />

                <label class="link mt-1">All</label>
              </div>
            </div>
          </div>
          <div class="field-wrap mx-2" style="width: 20%">
            <div class="form-group has-float-label">
              <label class="ms-2 p-0 d-flex align-items-center" for="All">
                Pct Complete GT
              </label>
              <input
                pInputText
                id="All"
                type="text"
                class="p-column-filter p-inputtext p-component"
                style="height: 35px"
                (input)="
                  dt.filter(
                    $any($event.target).value,
                    'orderPercentComplete',
                    'startsWith'
                  )
                " />
            </div>
          </div>
        </div>
      </div>

      <div class="col-12">
        <p-table
          #dt
          responsiveLayout="scroll"
          [value]="filterReadyToBillListing"
          [rowHover]="true"
          [scrollable]="true"
          [rows]="50"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 20, 50, 1000]"
          [autoLayout]="true"
          [resizableColumns]="true"
          [paginator]="filterReadyToBillListing.length >= 50"
          (onFilter)="onFilter($event)"
          stripedRows
          [rowHover]="true"
          [showCurrentPageReport]="true"
          scrollHeight="calc(100vh - 361px)"
          [size]="'small'"
          [paginator]="true"
          paginatorStyleClass="paginator-table"
          styleClass="table-listing">
          <ng-template pTemplate="header">
            <tr class="table-head">
              <th>Order #</th>
              <th
                class="orderPercentComplete"
                pSortableColumn="orderPercentComplete">
                % Costs
                <p-columnFilter
                  type="numeric"
                  field="orderPercentComplete"
                  display="menu"></p-columnFilter>
                <p-sortIcon field="orderPercentComplete"></p-sortIcon>
              </th>
              <th class="rsmSplitInvoice" pSortableColumn="rsmSplitInvoice">
                IP
                <p-sortIcon field="rsmSplitInvoice"></p-sortIcon>
              </th>
              <th class="inHandsDate" pSortableColumn="inHandsDate">
                In Hands Date
                <p-sortIcon field="inHandsDate"></p-sortIcon>
              </th>
              <th>Client Name</th>
              <th [ngClass]="{ trimmedby50char: descriptionCharacterCond }">
                Job Name
              </th>
              <th>Customer Account</th>
              <th [ngClass]="{ trimmedby50char: descriptionCharacterCond }">
                Billing Note
              </th>
              <th>BC</th>
              <th>Total Sell $</th>
              <th>Total Cost $</th>
              <th>Matched AP Cost $</th>
              <th>Pay Method</th>
              <th>Billed Cost $</th>
              <th>Unbilled Cost $</th>
              <th>Last Vendor Invoice Date</th>
              <th>First Vendor Invoice Date</th>
              <th>Margin $</th>
              <th>Gross Margin $</th>
              <th>Freight Method</th>
              <th>Freight Sales $</th>
              <th>% of Freight</th>
              <th>Sales Tax $</th>
              <th>Freight Matched %</th>
              <th>Prev Billed $</th>
              <th>Prebill $</th>
              <th>Project ID</th>
            </tr>
            <tr>
              <th>
                <div class="d-flex">
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="orderNumber"
                    id="orderNumber"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'orderNumber',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th></th>
              <th></th>
              <th class="">
                <jni-date-filter
                  [dataList]="detailReadyToBillLists"
                  [columnName]="inHandsDateColumn"
                  (emitCancelFilter)="clearFilter($event)"
                  (emitApplyFilter)="applyFilter($event)">
                </jni-date-filter>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="clientName"
                    id="clientName"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'clientName',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="rsmJobName"
                    id="rsmJobName"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'rsmJobName',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th></th>
              <th></th>
              <th>
                <div class="d-flex">
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="bcId"
                    id="bcId"
                    style="max-width: 200px"
                    (input)="
                      dt.filter($any($event.target).value, 'bcId', 'contains')
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th>
                <jni-date-filter
                  [dataList]="detailReadyToBillLists"
                  [columnName]="lastVendorInvoiceDateColumn"
                  (emitCancelFilter)="clearFilter($event)"
                  (emitApplyFilter)="applyFilter($event)">
                </jni-date-filter>
              </th>
              <th>
                <jni-date-filter
                  [dataList]="detailReadyToBillLists"
                  [columnName]="vsiJNIInvoiceDateColumn"
                  (emitCancelFilter)="clearFilter($event)"
                  (emitApplyFilter)="applyFilter($event)">
                </jni-date-filter>
              </th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
            <tr>
              <td>
                <a
                  class="link"
                  (click)="redirectToSummary(rowData.orderNumber)">
                  {{ rowData.orderNumber }}</a
                >
              </td>
              <td class="text-right">
                {{
                  rowData.orderPercentComplete
                    | hidevalueifzero
                    | number: "1.2-2"
                    | percentagesymbol
                }}
              </td>
              <td>
                <a
                  class="link"
                  (click)="
                    redirectToIpSummary(
                      rowData?.orderNumber,
                      rowData?.proposalId,
                      rowData?.rsmSplitInvoice,
                      rowData?.projId
                    )
                  ">
                  {{ rowData.rsmSplitInvoice }}</a
                >
              </td>
              <td>
                <span *ngIf="rowData.inHandsDate | hidedynamicsdate">
                  {{ rowData.inHandsDate | date: "MM-dd-yyyy" }}
                </span>
              </td>
              <td>
                <a
                  class="link"
                  (click)="redirectToClientSummary(rowData.customerAccount)">
                  {{ rowData.clientName }}</a
                >
              </td>
              <td
                [ngClass]="{
                  'trimmeddescription trimmedby50char':
                    descriptionCharacterCond,
                }">
                <a
                  class="link"
                  (click)="redirectToSummary(rowData.orderNumber)">
                  {{ descriptionCharacterCount(rowData.rsmJobName) }}
                  {{ rowData.rsmJobName }}</a
                >
              </td>
              <td>
                <a
                  class="link"
                  (click)="redirectToClientSummary(rowData.customerAccount)">
                  {{ rowData.customerAccount }}</a
                >
              </td>
              <td
                [ngClass]="{
                  'trimmeddescription trimmedby50char':
                    descriptionCharacterCond,
                }">
                {{ descriptionCharacterCount(rowData.rsmBillingNote)
                }}{{ rowData.rsmBillingNote }}
              </td>
              <td>{{ rowData.bcId }}</td>
              <td class="text-right">
                {{
                  rowData.totalSell
                    | hidevalueifzero
                    | currency: "USD" : "symbol" : "1.2-2"
                }}
              </td>
              <td class="text-right">
                {{
                  rowData.totalCost
                    | hidevalueifzero
                    | currency: "USD" : "symbol" : "1.2-2"
                }}
              </td>
              <td class="text-right">
                {{
                  rowData.matchedAPCost
                    | hidevalueifzero
                    | currency: "USD" : "symbol" : "1.2-2"
                }}
              </td>
              <td>{{ rowData.paymMode }}</td>
              <td class="text-right">
                {{
                  rowData.billedCost
                    | hidevalueifzero
                    | currency: "USD" : "symbol" : "1.2-2"
                }}
              </td>
              <td class="text-right">
                {{
                  rowData.unbilledCost
                    | hidevalueifzero
                    | currency: "USD" : "symbol" : "1.2-2"
                }}
              </td>
              <td>
                <span *ngIf="rowData.lastVendorInvoiceDate | hidedynamicsdate">
                  {{ rowData.lastVendorInvoiceDate | date: "MM-dd-yyyy" }}</span
                >
              </td>
              <td>
                <span *ngIf="rowData.vsiJNIInvoiceDate | hidedynamicsdate">
                  {{ rowData.vsiJNIInvoiceDate | date: "MM-dd-yyyy" }}</span
                >
              </td>
              <td class="text-right">
                {{
                  rowData.margin
                    | hidevalueifzero
                    | currency: "USD" : "symbol" : "1.2-2"
                }}
              </td>
              <td class="text-right">
                {{
                  rowData.grossMargin
                    | hidevalueifzero
                    | currency: "USD" : "symbol" : "1.2-2"
                }}
              </td>
              <td>{{ rowData.freightMethod }}</td>
              <td class="text-right">
                <a
                  class="link text-right"
                  (click)="redirectToFreightChargesPage(rowData.orderNumber)">
                  {{
                    rowData.freightSales | currency: "USD" : "symbol" : "1.2-2"
                  }}</a
                >
              </td>
              <td class="text-right">
                {{
                  rowData.percentageOfFreight
                    | hidevalueifzero
                    | number: "1.2-2"
                    | percentagesymbol
                }}
              </td>
              <td class="text-right">
                {{
                  rowData.salesTax
                    | hidevalueifzero
                    | currency: "USD" : "symbol" : "1.2-2"
                }}
              </td>
              <td class="text-right">
                {{
                  rowData.freightMatchedPercent
                    | hidevalueifzero
                    | number: "1.2-2"
                    | percentagesymbol
                }}
              </td>
              <td class="text-right">
                {{
                  rowData.prevBilledAmt
                    | hidevalueifzero
                    | currency: "USD" : "symbol" : "1.2-2"
                }}
              </td>
              <td class="text-right">
                {{
                  rowData.prebillAmt
                    | hidevalueifzero
                    | currency: "USD" : "symbol" : "1.2-2"
                }}
              </td>
              <td>{{ rowData.projId }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-card>
  </div>
</div>

<jni-modal-stacker
  class="modal-header-sticky"
  *ngIf="orderDisplayModal"
  [displayModal]="orderDisplayModal"
  (closeEvent)="closeModalForSaleOrder()">
  <h1 class="panelHeading">Order Summary</h1>
  <div class="panelBody">
    <jni-order-summary
      [isModal]="true"
      [saleOrderIdFromModal]="saleOrderId"
      (closeOrderSummaryModalEvent)="closeModalForSaleOrder()"
      (scrollHiddenStatus)="scrollHiddenStatus()"></jni-order-summary>
  </div>
</jni-modal-stacker>
<jni-modal-stacker
  *ngIf="clientDisplayModal"
  [displayModal]="clientDisplayModal"
  (closeEvent)="closeClientModal()">
  <h1 class="panelHeading">Client Summary</h1>
  <div class="panelBody">
    <jni-client-details
      [isModal]="true"
      [clientIdFromModal]="customerId"
      (closeEvent)="closeClientModal()">
    </jni-client-details>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  *ngIf="freightChargesDisplayModal"
  [displayModal]="freightChargesDisplayModal"
  (closeEvent)="closeModalForFreight()">
  <h1 class="panelHeading">Freight Charges</h1>
  <div class="panelBody">
    <jni-freight-charges
      [isModal]="true"
      [saleOrderId]="saleOrderId"
      (scrollHiddenStatus)="addScollHiddenClass()"
      (closeTrackingListModalEvent)="closeModalForFreight()">
    </jni-freight-charges>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  *ngIf="invoicePreviewSummaryDisplayModal"
  [displayModal]="invoicePreviewSummaryDisplayModal"
  (closeEvent)="closeModalForInvoicePreview()">
  <h1 class="panelHeading d-flex">Invoice Preview Summary</h1>
  <div class="panelBody">
    <jni-invoice-preview-summary
      [invoicePreviewNumberFromModal]="invoicePreviewNumber"
      [saleOrderId]="saleOrderId"
      (scrollHiddenStatus)="addScollHiddenClass()"
      (closeModalEvent)="
        closeModalForInvoicePreview()
      "></jni-invoice-preview-summary>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  *ngIf="invoiceReviewSummaryDisplayModal"
  [displayModal]="invoiceReviewSummaryDisplayModal"
  (closeEvent)="closeModalForInvoiceReview()">
  <h1 class="panelHeading d-flex">Invoice Review</h1>
  <div class="panelBody">
    <jni-invoice-review-summary
      [saleOrderId]="saleOrderId"
      [projId]="projId"
      (scrollHiddenStatus)="addScollHiddenClass()"
      (closeModalEvent)="
        closeModalForInvoiceReview()
      "></jni-invoice-review-summary>
  </div>
</jni-modal-stacker>
